export default class TrustindexTopRatedWidget {
	constructor(widget)
	{
		this.widget = widget;

		this.addEvents();
	}

	addEvents()
	{
		this.widget.querySelectorAll('.ti-verified-by').forEach(verifiedBy => {
			let disclaimer = this.getDisclaimer(verifiedBy);
			if (!disclaimer) {
				return;
			}

			verifiedBy.addEventListener('mouseenter', () => {
				this.alignDisclaimerVertically(disclaimer);
				this.alignDisclaimerHorizontally(disclaimer);
			});
		});
	}

	getDisclaimer(verifiedBy)
	{
		let disclaimer = verifiedBy.querySelector('.ti-disclaimer');
		if (disclaimer) {
			return disclaimer;
		}

		let sibling = verifiedBy.nextElementSibling;

		return sibling && sibling.matches('.ti-disclaimer') ? sibling : null;
	}

	alignDisclaimerVertically(disclaimer)
	{
		disclaimer.classList.remove('ti-bottom');

		if (disclaimer.getBoundingClientRect().y < 0) {
			disclaimer.classList.add('ti-bottom');
		}
	}

	alignDisclaimerHorizontally(disclaimer)
	{
		let rect = disclaimer.getBoundingClientRect();

		let appliedOffset = parseFloat(getComputedStyle(disclaimer).translate) || 0;
		let left = rect.left - appliedOffset;
		let right = rect.right - appliedOffset;
		let marginLeft = 10;
		let maxRight = document.documentElement.clientWidth - marginLeft;

		let offset = 0;
		if (left < marginLeft) {
			offset = marginLeft - left;
		} else if (right > maxRight) {
			offset = Math.max(maxRight - right, marginLeft - left);
		}

		disclaimer.style.setProperty('--ti-disclaimer-offset', Math.round(offset) + 'px');
	}
};
